import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * System Module Service Stores
 */
export const systemStores: ServiceStoreConfig[] = [
  {
    name: "api-services",
    options: { enableStorage: false, enableErrorNotifications: false },
  },
  {
    name: "azure-blob-storage",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  // Add other system services as they are implemented
  // app-version, health, log, removed-items, update-history, weather
];